export class Menu {
	label!: string;
	children!: MenuItem[];
}

export class MenuItem {
	label!: string;
	path?: string;
	icon?: string;
	acl?: string | string[];
	aclOr?: boolean = false;
	group?: MenuItem[];
}

const menu: Menu[] = [
	{
		label: 'amministrazione',
		children: [
			{
				label: 'utenti',
				path: '/utenti',
				icon: 'users',
				acl: 'section.utenti'
			},
			{
				label: 'ruoli',
				path: '/ruoli',
				icon: 'user-lock',
				acl: 'section.ruoli'
			},
			{
				label: 'liste',
				path: '/liste',
				icon: 'list',
				acl: 'section.liste'
			},
			{
				label: 'sedi',
				path: '/sedi',
				icon: 'home',
				acl: 'section.headquarters'
			},
			{
				label: 'tipologieservizio',
				path: '/tipologieservizio',
				icon: 'palette',
				acl: 'section.tipologieservizio'
			},
			{
				label: 'tipologieintervento',
				path: '/tipologieintervento',
				icon: 'flag',
				acl: 'section.tipologieintervento'
			},
			{
				label: 'conti',
				path: '/conti',
				icon: 'search-dollar',
				acl: 'section.conti'
			},
			{
				label: 'luoghi',
				path: '/luoghi',
				icon: 'map-marker',
				acl: 'section.luoghi'
			}
		]
	},
	{
		label: 'sede',
		children: [
			{
				label: 'sede',
				path: '/sede',
				icon: 'home',
				acl: 'section.sede'
			},
			{
				label: 'anagrafica',
				icon: 'users',
				group: [
					{
						label: 'people',
						path: '/attori',
						icon: 'users',
						acl: 'section.attori'
					},
					{
						label: 'volunteers',
						path: '/volunteers',
						icon: 'users',
						acl: 'section.volontari'
					},
					{
						label: 'associates',
						path: '/associates',
						icon: 'users',
						acl: 'section.associati'
					},
					{
						label: 'patients',
						path: '/patients',
						icon: 'users',
						acl: 'section.pazienti'
					},
					{
						label: 'doctors',
						path: '/doctors',
						icon: 'users',
						acl: 'section.dottori'
					}
				]
			},
			{
				label: 'contatti',
				path: '/contatti',
				icon: 'address-book',
				acl: 'section.contatti'
			},
			{
				label: 'vehicles',
				path: '/veicoli',
				icon: 'truck',
				acl: 'section.veicoli'
			},
			{
				label: 'campagne',
				path: '/campagne',
				icon: 'bullhorn',
				acl: 'section.campagne'
			},
			{
				label: 'callcenter',
				path: '/callcenter',
				icon: 'headset',
				acl: 'section.callcenter'
			},
			{
				label: 'stat-callcenter',
				path: '/stat-callcenter',
				icon: 'chart-bar',
				acl: 'section.stat-callcenter'
			},
			{
				label: 'operatori',
				path: '/operatori',
				icon: 'headset',
				acl: 'section.operatori'
			},
			{
				label: 'fattorini',
				path: '/fattorini',
				icon: 'truck',
				acl: 'section.fattorini'
			},
			{
				label: 'offers',
				path: '/riscossioni',
				icon: 'coins',
				acl: 'section.riscossioni'
			},
			{
				label: 'servizi',
				path: '/servizi',
				icon: 'parking',
				acl: 'section.servizi'
			},
			{
				label: 'servizi-periodici',
				path: '/servizi-periodici',
				icon: 'history',
				acl: 'section.serviziperiodici'
			},
			{
				label: 'calendario-servizi',
				path: '/calendario-servizi',
				icon: 'calendar',
				acl: 'section.calendarioservizi'
			},
			{
				label: 'cassa',
				path: '/cassa',
				icon: 'wallet',
				acl: 'section.cassa'
			}
		]
	}
];

export default menu;